// @flow
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {
  PrimaryGreen,
  SecondaryGreen,
  ThirdGreen,
  WhiteText,
  BlackText,
  GreyText,
  InvalidText,
  WarningText,
  DarkGreen,
  GreyLightText,
  PrimaryRed,
  LightRed,
  DardRed,
  BlueText
} from "./scss";

export const LightTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    common: {
      black: BlackText,
      white: WhiteText
    },
    primary: {
      light: SecondaryGreen,
      main: PrimaryGreen,
      dark: DarkGreen,
      third: ThirdGreen,
      contrastText: WhiteText
    },
    secondary: {
      light: LightRed,
      main: PrimaryRed,
      dark: DardRed
    },
    error: {
      main: InvalidText
    },
    grey: {
      main: GreyText,
      light: GreyLightText
    },
    warning: {
      main: WarningText
    },
    blue: {
      main: BlueText
    }
  },
  overrides: {
    MuiTableHead: {
      root: {
        fontSize: "0.9375rem"
      }
    },
    MuiTableBody: {
      root: {
        fontSize: "0.9375rem"
      }
    },
    MuiExpansionPanelDetails: {
      root: {
        display: "block"
      }
    },
    MuiTooltip: {
      tooltipPlacementBottom: {
        fontSize: "0.8125rem"
      },
      tooltipPlacementTop: {
        fontSize: "0.8125rem"
      },
      tooltipPlacementLeft: {
        fontSize: "0.8125rem"
      },
      tooltipPlacementRight: {
        fontSize: "0.8125rem"
      }
    },
    MuiCard: {
      root: {
        overflow: "visible"
      }
    }
  }
});
